import React, { Component } from 'react';
import { Col, Row, Label, Input, InputGroup } from 'reactstrap';
import { connect } from 'react-redux';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";
import { MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../../utils/Constants';

class PaymentTypesList extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            isMenuuAdminOrMasterAdmin: false
        }
    }
    componentDidMount() {
        const { user } = this.props;
        this.setState({
            isMenuuAdminOrMasterAdmin: user.role === MENUU_ADMIN || user.role === MENUU_MASTER_ADMIN ? true : false
        })
    }

    renderAllTenderTypes() {
        const { checkboxInput } = this.props.styles;
        const { tenderTypes } = this.props;
        const { isMenuuAdminOrMasterAdmin } = this.state;
        
        if (tenderTypes !== undefined && tenderTypes !== null) {
            return tenderTypes.map((tenderType, i) => {

                const transformToLocalize = () => {
                    switch (tenderType.value) {
                        case "Credit card":
                            return "creditCard";
                        case "Cash":
                            return "cash";
                        case "Coupon":
                            return "coupon";
                        case "Stripe":
                            return "stripe";
                        case "Authipay":
                            return "authipay";
                        default:
                            return;
                    }
                }


                let isDisabled = false;
                let handleChange = this.props.changeSelectedTenderTypesState;
                
                if (tenderType.value === "Credit card" && !isMenuuAdminOrMasterAdmin) {
                  isDisabled = true;
                  handleChange = null;
                }

                return (
                    <InputGroup key={tenderType.id + i}>
                        <Label for={tenderType.value} style={isDisabled ? { color: '#c3c3c3', fontWeight: 700 } : {}} >{i18n.t(`common:paymentTypes.${transformToLocalize(tenderType.value)}`)}</Label>
                        <Input type="checkbox" name={tenderType.value} id={tenderType.id} style={checkboxInput}
                            checked={this.checkedIfMatches(tenderType.id)}
                            onChange={handleChange}
                            disabled={isDisabled}
                        />
                    </InputGroup>
                );
            });
        }
    }

    checkedIfMatches(tenderTypeId) {
        const { supportedTenderTypes } = this.props;

        if (supportedTenderTypes !== undefined && supportedTenderTypes !== null && supportedTenderTypes.length > 0) {
            for (let i = 0; i < supportedTenderTypes.length; i++) {
                const currentTenderType = supportedTenderTypes[i];

                if (currentTenderType.id == tenderTypeId) {
                    return true;
                }
            }
        }

        return false;
    }

    render() {
        const { headerStyle, headerTitle, rowStyler, columnGroup, containerStyle } = this.props.styles;

        return (
            <Col style={containerStyle}>
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="local_atm" color="#000" size={20} color="#0288d1"/>
                        <span style={headerTitle}>{i18n.t('common:deliveryCollectionDineInCurbside.paymentTypes')}</span>
                    </div>
                </Row>
                <Row style={rowStyler}>
                    <Col style={columnGroup}>{this.renderAllTenderTypes()}</Col>
                </Row>
            </Col>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};
export default connect(mapStateToProps)(PaymentTypesList);


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/PaymentTypesList.js